import { X } from "lucide-react";
import { getPasswordRequirements } from "@/libs/password";

type Labels = { heading: string; minLength: string; uppercase: string; lowercase: string; number: string; symbol: string };
export default function PasswordRequirements({ password, labels }: { password: string; labels?: Labels }) {
  const requirements = getPasswordRequirements(password);
  const unmetRequirements = requirements.filter(({ met }) => !met);

  if (password.length > 0 && unmetRequirements.length === 0) {
    return null;
  }

  return (
    <div aria-live="polite" className="mt-1 rounded-md bg-gray-50 px-3 py-2">
      <p className="text-xs text-gray-500">{labels?.heading ?? "Your password needs:"}</p>
      <ul className="mt-1 space-y-1" aria-label={labels?.heading ?? "Password requirements"}>
        {unmetRequirements.map(({ key, label }) => (
          <li
            key={key}
            className="flex items-center gap-1.5 text-xs text-gray-500"
          >
            <X aria-hidden="true" size={14} />
            {labels?.[key] ?? label}
          </li>
        ))}
      </ul>
    </div>
  );
}
